import t from"react";import{mdiAccount as o}from"@mdi/js";import{MdIcon as r}from"./MdIcon.js";const c=({id:c="account",title:e="Account",...i})=>t.createElement(r,{id:c,title:e,path:o,...i});export{c as AccountIcon};
